import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';

const ProductImageClip = props => (
  <span className={Classes.customInvitive}>{props.text}<span className={Classes.triangle} />
  </span>
);

ProductImageClip.propTypes = {
  text: PropTypes.string.isRequired
};

export default ProductImageClip;
